$(function() {

  // ハンバーガーメニューの開閉
  function humMenuControll(target){
    var header = $('header')
    var humButton = $('#humButton');
    var humState = 0;
    var humLinks = [];
    var humBg = [];
    var navImg = $('#navImg');
    var bgState = 'none';

    function hummenuMove(){
      if(humState == 0){
        target.addClass('open');
        humButton.addClass('hum_open');
        humState = 1;
      }else{
        target.removeClass('open');
        humButton.removeClass('hum_open');
        humState = 0;
      }
    }

    function humBgChange(e){
      if(bgState != humBg[e]){
        $.each(navImg.find('img'), function(index) {
          if(humBg[e] == $(this).attr('id')){
            $(this).css('display', 'block');
          }else{
            $(this).css('display', 'none');
          }
        });
        bgState = humBg[e];
      }
    }

    function init(){
      humButton.on({
        'click': function() {
          hummenuMove();
        }
      });

      $.each(target.find('a'), function(index) {
        humLinks[index] = $(this);
        humBg[index] = humLinks[index].attr("bgType");
        if(window.outerWidth > 700){
          humLinks[index].on({
            'mouseover': function() {
              humBgChange(index);
            }
          });
        }
      });
    }

    init();
  }

  humMenuControll($('#hummenu'));

  function preSetScript(){

    var COOKIES = COOKIES || {
        /*
         指定したcookieの値を取得して返す関数
         第1引数=取得したいcookiename
        */
        getCookie: function(cName) {
            var cookie_name = cName;
            if(cookie_name == '' || cookie_name == null) {
                console.log('COOKIES.getCookie：引数に値を代入してください。');
            } else {
                var set_replace = '(?:(?:^|.*\s*)' + cookie_name + '\s*\=\s*([^;]*).*$)|^.*$';
                var cookie_value = document.cookie.replace(new RegExp(set_replace), '$1');
                return cookie_value;
            }
        },
        /*
         指定したcookieを追加する関数
         第1引数=追加するcookiename;第2引数=追加するcookievalue;第3引数=cookieの有効期限(day)
        */
        setCookie: function(cName, cValue, cTime) {
            var cookie_name = cName;
            var cookie_Value = cValue;
            var cookie_domain = location.hostname;
            var cookie_time = cTime ? (60 * 60 * 24) * cTime : '';
            if(cookie_name == '' || cookie_name == null) {
                console.log('COOKIES.setCookie：第1引数に値を代入してください。')
            } else {
                document.cookie = cookie_name + '=' + cookie_Value + ';domain=' + cookie_domain + ';max-age=' + cookie_time;
            }
        },
        /*
         指定したcookieの値を削除する関数
         第1引数=削除したいcookiename
        */
        deleteCookie: function(cName) {
            var cookie_name = cName;
            if(cookie_name == '' || cookie_name == null) {
                console.log('COOKIES.deleteCookie：引数に値を代入してください。');
            } else {
                COOKIES.setCookie(cookie_name, '', 0);
            }
        }
    };

    // タブレットレイアウトをPCと統一
    var metaDiscre = document.head.children;
    var metaLength = metaDiscre.length;
    if(window.outerWidth > 700 && window.outerWidth < 1200){
      for(var i = 0;i < metaLength;i++){
        var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1200');
        }
      }
    }

    // スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const position = document.documentElement;
      let wWidth = 0;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;
      let sectionTop = [];

      function setHeightProperty() {
        wHeight = window.innerHeight;
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scrollPx', window.scrollY + 'px');
        position.style.setProperty('--scroll', window.scrollY);
        sectionTop = [];

        target.find('section').each(function(index) {
          sectionTop[index] = $(this).offset().top;
          if(sectionTop[index] != 0){
            position.style.setProperty('--topPx' + index, Math.floor(sectionTop[index]) + 'px');
            position.style.setProperty('--top' + index, Math.floor(sectionTop[index]));
          }else{
            position.style.removeProperty('--top');
            position.style.removeProperty('--topPx');
          }
        });

        $(".effect").each(function() {
          var imgPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > imgPos - windowHeight + windowHeight / 3) {
            $(this).removeClass('effect');
          }else{
            $(this).addClass('effect');
          }
        });

        if (document.getElementById('product')) {
          /*
          var relationTop = $('#relationProducts').offset().top;
          if(window.scrollY > Math.floor(relationTop) - window.innerHeight - 120){
            position.style.setProperty('--prodImgPx', Math.floor(relationTop) - window.innerHeight - 120 + 'px');
          }else{
            position.style.setProperty('--prodImgPx', window.scrollY + 'px');
          }
          */
        }
        setTimeout(function() {
          setProperties();
        }, 32);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
        /*window.addEventListener('scroll', _.throttle(setProperties, 100, { leading: true, trailing: true}));
        window.addEventListener('resize', _.throttle(setProperties, 100, { leading: true, trailing: true}));*/
      }

      init();

    }

    scrollAnimationSet($('article'));

    // トップページ ローディングアニメーション

    function loadingAnimatonSet(){
      var mainProduct = $('#mainProduct');
      var pageBg = $('#pageBg');

      function init(){
        pageBg.addClass('loaded');
        mainProduct.addClass('loaded');
        var visited = COOKIES.getCookie('visited');
        console.log('code:' + visited);
        console.log('indexof' + visited.indexOf('visited'));
        if (document.getElementById('noticePop') && visited.indexOf('visited') == -1){
          var date1,date2;
          var kigen = 365;
          date1 = new Date();
          date1.setTime(date1.getTime() + kigen*48*60*60*1000);
          date2 = date1.toGMTString();
          document.cookie = 'visited=visited; path=/';
          document.cookie = 'max-age=' + date2 + '; path=/';
          setTimeout(function() {
            $('#noticePop').addClass('open');
            $('#popCloseBg').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
            $('#modalClose').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
            $('#continueButton').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
          }, 3000);
        }
      }

      setTimeout(function() {
        init();
      }, 1000);

    }

    loadingAnimatonSet();


    //言語切り替え表示の制御
    function langChangePop(){
      var visited = COOKIES.getCookie('visited');
      console.log('code:' + visited);
      console.log('indexof' + visited.indexOf('visited'));

      function init(){
        if (visited.indexOf('visited') == -1){
          var date1,date2;
          var kigen = 365;
          date1 = new Date();
          date1.setTime(date1.getTime() + kigen*48*60*60*1000);
          date2 = date1.toGMTString();
          document.cookie = 'visited=visited; path=/';
          document.cookie = 'max-age=' + date2 + '; path=/';
          setTimeout(function() {
            $('#noticePop').addClass('open');
            $('#popCloseBg').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
            $('#modalClose').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
            $('#continueButton').on({
              'click': function() {
                $('#noticePop').removeClass('open');
              }
            });
          }, 3000);
        }
      }

      init();

    }

    if(document.getElementById('noticePop')){
      langChangePop();
    }



    //商品詳細ページ サムネイルの切り替え
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbSrcSet = [];
      let thumbBox = target.find('.thumb_img');
      let thumbImage = thumbBox.find('img');
      let slideNum = target.find('.thumbnails').find('img').length;
      const time = 200;
      let currentSlide = 0;
      console.log('slideNum:' + slideNum);

      function switchImage(num){
        console.log('num:' + num);
        thumbBox.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            thumbBox.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        $('#thumnails').css({'max-height': thumbHeight + 'px'});
        requestAnimationFrame(thumbHeightControll);
      }

      function slideNext(){
        if (currentSlide < slideNum - 1) {
          currentSlide = currentSlide + 1;
        } else {
          currentSlide = 0;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function slidePrev(){
        if (currentSlide == 0) {
          currentSlide = slideNum - 1;
        } else {
          currentSlide = currentSlide - 1;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function tabTouch(){
        if(startTouchX - endTouchX > 50){
          slideNext();
        }else if(startTouchX - endTouchX < - 50){
          slidePrev();
        }
      };

      function windowDrag() {
        if (startDragX - endDragX > 100) {
          slideNext();
        } else if (startDragX - endDragX < -100) {
          slidePrev();
        }
      };

      function init(){
        thumbHeightControll();
        $.each(target.find('.thumbnails').find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });

        thumbBox.find('img').on({
          'dragstart': function(e) {
            event.preventDefault();
            startDragX = event.pageX;
          },
          'dragend': function(e) {
            endDragX = event.pageX;
            windowDrag();
          }
        });

        thumbBox.find('img').on({
          'touchstart' : function(e){
            event.preventDefault();
            startTouchX = event.changedTouches[0].pageX;
          },
          'touchmove' : function(e){
          },
          'touchend' : function(e){
            endTouchX = event.changedTouches[0].pageX;
            tabTouch();
          }
        });

        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('product')) {
      thumbSwitcher($('#imagesPc'));
      thumbSwitcher($('#imagesSp'));
    }

    // 使用上の注意ポップアップ
    function cautionsPopControll(){
      var cautionsPop = $('#cautionsPop');
      var proposalPlan = $('#proposalPlan');
      var detailPopBg = $('#detailPopBg');
      var detailCloseButton = $('#detailCloseButton');
      var noticePopButton = $('#noticePopButton');

      function detailPopOpen(){
        cautionsPop.addClass('open');
      }


      function detailPopClose(){
        cautionsPop.removeClass('open');
      }

      function init(){

        noticePopButton.on({
          'click': function() {
            detailPopOpen();
          }
        });

        detailPopBg.on({
          'click': function() {
            detailPopClose();
          }
        });

        detailCloseButton.on({
          'click': function() {
            detailPopClose();
          }
        });

      }

      init();

    }

    if (document.getElementById('cautionsPop')) {
      cautionsPopControll();
    }

    // 送料詳細のポップアップ
    function shippingPopDisplay(){
      var shippingFeePop = $('#shippingFeePop');
      var shippingPopBg = $('#shippingPopBg');
      var shippingPopClose = $('#shippingPopClose');

      function init(){

        $.each($('body').find('.func-shipping-fee'), function(index) {
          console.log('index:' + index);
          $(this).on({
            'click': function() {
              shippingFeePop.addClass('open');
            }
          });
        });

        shippingPopBg.on({
          'click': function() {
            shippingFeePop.removeClass('open');
          }
        });

        shippingPopClose.on({
          'click': function() {
            shippingFeePop.removeClass('open');
          }
        });

      }

      init();

    }

    if (document.getElementById('shippingFeePop')) {
      shippingPopDisplay();
    }


    // カートページ 商品数の増減
    function controllProductQuantity(target){
      var minusButton = [];
      var plusButton = [];
      var quantityInput = [];
      var reloadButton = [];
      var quantityNum;

      function controllQuantity(num, vector){
        quantityNum = quantityInput[num].val();
        if(vector == 1){
          quantityInput[num].attr('value', Number(quantityNum) + 1);
          reloadButton[num].click();
        }else{
          if(quantityNum != 1){
            quantityInput[num].attr('value', Number(quantityNum) - 1);
            reloadButton[num].click();
          }
        }
      }

      function init(){
        $.each(target.find('.cart_item'), function(index) {
          minusButton[index] = $(this).find('.minus');
          plusButton[index] = $(this).find('.plus');
          quantityInput[index] = $(this).find('input[type="number"]');
          reloadButton[index] = $(this).find('.reload_button');
          minusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, -1);
            }
          });
          plusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, 1);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('cartItem')) {
      controllProductQuantity($('#cartItem'));
    }

    /* カートページの切り替えレイアウト */
    function switchCartFunction(target){
      /* 各画面 */
      var inviteCode = $('#inviteCode');
      var registerMember = $('#registerMember');
      var cartContents = $('#cartContents');
      /* 画面の切り替えボタン*/
      var registerButton = $('#registerButton');
      var inviteButton = $('#inviteButton');
      var inviteCodeInput = $('input[name=invitecode]');

      /* 招待コードの入力周り */
      var inviteSubmit = $('#inviteSubmit');
      var codeTxt = 'DFH24'

      /* Cookieのステータス*/
      var history = COOKIES.getCookie('code');
      console.log('code:' + history);

      function switchRegister(){
        target.animate({opacity:0}, 400, function(){
            registerMember.css({'display': 'block'});
            inviteCode.css({'display': 'none'});
            setTimeout(function() {
              target.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchInvite(){
        target.animate({opacity:0}, 400, function(){
            registerMember.css({'display': 'none'});
            inviteCode.css({'display': 'block'});
            setTimeout(function() {
              target.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function inviteCodeSubmit(){
        console.log(inviteCodeInput.val());
        document.cookie = 'history=; path=/;'
        document.cookie = "max-age=0; path=/";
        var date1,date2;
        var kigen = 365;
        var code = inviteCodeInput.val();
        if(code == codeTxt){
          date1 = new Date();
          date1.setTime(date1.getTime() + kigen*48*60*60*1000);
          date2 = date1.toGMTString();
          document.cookie = 'code=' + code + '; path=/';
          document.cookie = 'max-age=' + date2 + '; path=/';
          setTimeout(function() {
            window.location.reload();
          }, 500);
        }else{
          alert('招待コードを正しく入力してください。');
        }
      }

      function init(){

        if( history.indexOf(codeTxt) != -1){
          cartContents.css({'display': 'block'});
          console.log('yes');
        }else{
          inviteCode.css({'display': 'block'});
          console.log('no');
        }

        registerButton.on({
          'click': function() {
            event.preventDefault();
            switchRegister();
          }
        });

        inviteButton.on({
          'click': function() {
            event.preventDefault();
            switchInvite();
          }
        });

        inviteSubmit.on({
          'click': function() {
            inviteCodeSubmit();
          }
        });



      }

      init();

    }

    if (document.getElementById('cartContentSwiter')) {
      switchCartFunction($('#cartContentSwiter'));
    }

    // FAQの開閉処理
    function faqToggle(target) {
      var toggleItem = [];
      var toggleButton = [];
      var toggleContents = [];
      var toggleState = [];
      var toggleTitleTxt = [];
      var toggleContentsTxt = [];
      var faqSearch = $('#faqSearch');
      var faqFlex = $('#faqContents');
      var windowW = window.innerWidth;

      function filterFaqItem(){
        var searchValue = faqSearch.val();
        $.each(target.find('.toggle_item'), function(index) {
          if(searchValue.length > 1){
            if(toggleTitleTxt[index].indexOf(searchValue) != -1 || toggleContentsTxt[index].indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
        $.each(target.find('.comp-faq-contents'), function(index) {
          if(searchValue.length > 1){
            if($(this).text().indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
        $.each(target.find('.item_wrap'), function(index) {
          if(searchValue.length > 1){
            if($(this).text().indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
      }

      function toggleMove(e) {
        if ( toggleState[e] == 0 ) {
          toggleButton[e].addClass('active');
          var buttonHeight = toggleButton[e].innerHeight();
          var tagetHeight = toggleContents[e].innerHeight();
          toggleItem[e].css({
            'height': buttonHeight + tagetHeight + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleButton[e].removeClass('active');
          var buttonHeight = toggleButton[e].innerHeight();
            toggleItem[e].css({
              'height': buttonHeight + 2 + 'px'
            });
          toggleState[e] = 0;
        }
      }

      function setToggleHeight(){
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          $(this).css({'height': toggleButton[index].innerHeight() + 2 + 'px'});
          toggleState[index] = 0;
        });
      }

      function windowChecker(){
        var currentWindow = window.innerWidth;
        if(currentWindow != windowW){
          setToggleHeight();
          windowW = currentWindow
        }
        requestAnimationFrame(windowChecker);
      }

      function init() {
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          $(this).css({'height': toggleButton[index].innerHeight() + 2 + 'px'});
          toggleState[index] = 0;
          toggleTitleTxt[index] = toggleButton[index].text();
          toggleContentsTxt[index] = toggleContents[index].text();
          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });
        });
        if (document.getElementById('faq')) {
          faqSearch.on({
            'blur': function(){
              faqFlex.stop().animate({opacity: 0}, 300);
              setTimeout(function() {
                filterFaqItem();
                faqFlex.stop().animate({opacity: 1}, 300);
              }, 300);
            }
          });
        }
        windowChecker();
      }

      init();

    }

    if (document.getElementById('faq')) {
      faqToggle($('article'));
    }

    // 店舗一覧・FAQの目次ボタン
    function indexAnker(target){
      var ankerButton = [];
      var scrollTarget = [];

      function windowMove(e) {
        var headerHeight = $('header').outerHeight();
        var scrollHeight = $(scrollTarget[e]).offset().top;
        var adScroll = scrollHeight - headerHeight;
        $("html, body").animate({
          scrollTop: adScroll
        }, 500);
      }


      function init(){
        target.find('button').each(function(index) {
          ankerButton[index] = $(this);
          scrollTarget[index] = $(this).attr('jump');
          ankerButton[index].on({
            'click': function() {
              windowMove(index);
            }
          });
        });
      }

      init();

    }

    if (document.getElementById('stockist')) {
      indexAnker($('#categoryList'));
    }

    if (document.getElementById('faq')) {
      indexAnker($('#categoryList'));
    }

    /* ログインページの切り替えレイアウト */
    function switchLoginFunction(){
      var loginLayout = $('#login');
      var resetLayout = $('#reset');
      var resetPassword = $('#resetPassword');
      var loginBack = $('#loginBack');

      function switchLogin(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'block'});
            resetLayout.css({'display': 'none'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchReset(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'none'});
            resetLayout.css({'display': 'block'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){

        resetPassword.on({
          'click': function() {
            event.preventDefault();
            switchReset();
          }
        });

        loginBack.on({
          'click': function() {
            event.preventDefault();
            switchLogin();
          }
        });

      }

      init();

    }

    if (document.getElementById('contentSwitcher')) {
      switchLoginFunction();
    }

    /* 住所一覧ページの切り替えレイアウト */
    function switchAddressFunction(){
      var addressContentWrap = $('#addressContentWrap');
      var wrapperList = $('#wrapperList');
      var wrapperAdd = $('#wrapperAdd');
      var addressList = $('#addressList');
      var addressEdit = $('#addressEdit');
      var adminBar = $('#adminBar');
      var editbutton = [];
      var editId = [];


      function switchList(){
        adminBar.removeClass('mode-edit').addClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          wrapperList.css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
        });
      }

      function switchAdd(){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            wrapperAdd.css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchEdit(e){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            $('#' + editId[e]).css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){
        addressList.on({
          'click': function() {
            event.preventDefault();
            switchList();
          }
        });

        addressEdit.on({
          'click': function() {
            event.preventDefault();
            switchAdd();
          }
        });

        $.each($('article').find('.btn_edit'), function(index) {
          editbutton[index] = $(this);
          editId[index] = $(this).attr('formId');
          editbutton[index].on({
            'click': function() {
              console.log(editId[index]);
              switchEdit(index);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('addressContentWrap')) {
      switchAddressFunction();
    }

    // お問い合わせフォームの送信とバリデーション
    function setMyForm(target){
      var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
      var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
      var errorCount = 0;
      var submitWrap = $('#submit');
      var submitButton = $('#submitButton input');
      var items = []; //チェック対象となるテキスト入力要素を格納した配列
      if(location.host == 'diffar.jp'){
        var nameArart = '※お名前を入力してください。';
        var mailInputArart = '※メールアドレスをご入力ください。';
        var mailFormatArrat = '※アドレスの形式をご確認ください';
        var mailComfirmArart = '※確認用メールアドレスは必須です。';
        var mailNoMatch = '※メールアドレスが一致しません。';
        var contentArart = '※ご相談内容を入力してください。';
      }else{
        var nameArart = '*Please enter your name.';
        var mailInputArart = '*Please enter your email address.';
        var mailFormatArrat = '*Please check the address format';
        var mailComfirmArart = '*Please enter your email address for confirmation.';
        var mailNoMatch = '*Email addresses do not match with former input.';
        var contentArart = '*Please enter the details of your inquiry.';
      }

      //項目チェックする
      var checkAll = function(){
        errorCount = 0;

        //input,textareaのチェック
        for( var i=0; i<items.length; i++ ){
          if( items[i].prop('isSuccess') == false ){
            errorCount++;
            console.log('error:' + i);
          };
        };

        if( errorCount == 0 ){
        }else{
        };
      };

      //エラーメッセージの追加
      var addErrorMessage = function(selector, msg){
        removeErrorMessage(selector);
        selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
        selector.addClass(ERROR_INPUT_CLASSNAME);
      };

      //エラーメッセージの削除
      var removeErrorMessage = function(selector){
        var msgSelector = selector.parent().parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
        if( msgSelector.length != 0 ){
          msgSelector.remove();
          selector.removeClass(ERROR_INPUT_CLASSNAME);
        };
      };

      //input,textareaの未入力チェック
      var checkEmptyText = function(selector, msg){
        if( selector.val() == '' ||  selector.val() == null){
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        }else{
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        };
      };

      var emptyThrough = function(selector){
        if( selector.val() == '' ||  selector.val() == null){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }
      };

      //radioの未入力チェック
      var checkRadioBox = function(selector, msg){
        if( selector.prop("checked")){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }else{
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        };
      };

      //文字列のフォーマットチェック
      function checkFormatText(selector, _mode, msg){
        var value = selector.val();
        switch(_mode){
          //全角のみ
          case 0:
            if(value.match(/^[^ -~｡-ﾟ]*$/)){
              selector.prop('isSuccess', true);
              removeErrorMessage(selector);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //ふりがなのみ
          case 1:
            if(value.match(/^[\u3040-\u309F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //半角数字のみ
          case 2:
            if(value.match(/^[0-9\-]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //メールアドレスかどうか
          case 3:
            if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //カタカナのみ
          case 4:
            if(value.match(/^[\u30A0-\u30FF]+$/) || value.match(/^[\uFF61-\uFF9F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //全てエラーにする
          case 5:
            selector.prop('isSuccess', false);
            break;
        };
        if( selector.prop('isSuccess') == false ){
          addErrorMessage(selector, msg);
        }else{
          removeErrorMessage(selector);
        };
      };

      //初期設定
      var init = function(){
        //submitイベントの設定
        target.on({
          'submit': function(){
            checkAll();
          }
        });
        //input要素を配列に格納
        items = [
          target.find('input[name="yourName"]'), //0 お名前
          target.find('input[name="yourMail"]'), //1 メールアドレス
          target.find('input[name="yourMail2"]'), //2 メールアドレス確認用
          target.find('textarea[name="contents"]'), //3 ご相談内容
          target.find('input[name=agreement]'), //4 プラポリへの合意
        ];
        //input要素のプロパティを設定
        $.each(items, function(index){
          items[index].prop('isSuccess', false);
        });

        //enterキーでsubmitしてしまうのを防止する
        target.find('input[type=text]').on({
          'keypress': function(e){
            if( (e.keyCode == 13) ) return false;
          }
        });
        //0 お名前
        items[0].on({
          'blur': function(){
            checkEmptyText( items[0], nameArart );
            checkAll();
          }
        });

        //1 メールアドレス
        items[1].on({
          'blur': function(){
            checkEmptyText( items[1], mailInputArart );
            if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, mailFormatArrat );
            checkAll();
          }
        });

        //3 メールアドレス(確認用)
        items[2].on({
          'blur': function(){
            checkEmptyText( items[2], mailComfirmArart);
            if( items[2].prop('isSuccess') ){
              checkFormatText( items[2], 3, mailFormatArrat );
              if(items[1].val() != items[2].val()){
                checkFormatText( items[3], 5, mailNoMatch );
              }
            }

            checkAll();

          }
        });

        //4 ご相談内容
        items[3].on({
          'blur': function(){
            checkEmptyText( items[3], contentArart );
            checkAll();
          }
        });

        //5 プラポリへの合意
        items[4].prop('isSuccess', true);

        items[4].on({
          'change': function(){
            var agreeState = $('input[name=agreement]:checked').val();
            if(agreeState == 1){
              $('#submitButton').removeClass('disabled');
            }else{
              $('#submitButton').addClass('disabled');
            }
          }
        });

        submitButton.on({
          'click': function(){
            checkEmptyText( items[0], nameArart );
            checkEmptyText( items[1], mailInputArart );
            if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, mailFormatArrat );
            checkEmptyText( items[2], mailComfirmArart);
            if( items[2].prop('isSuccess') ){
              checkFormatText( items[2], 3, mailFormatArrat );
              if(items[1].val() != items[2].val()){
                checkFormatText( items[3], 5, mailNoMatch );
              }
            }
            checkEmptyText( items[3], contentArart );

            checkAll();
            console.log('errorCount:' + errorCount);
            if( errorCount == 0 ){
              processOrderContent();
            }else{
              if(location.host == 'diffar.jp'){
                alert('入力内容に不備があります。入力内容を確認いただき、再度送信ボタンを押してください。');
              }else{
                alert('There is a problem with the input content. Please check the entered information and press the send button again.');
              }

              var scrollHeight = $('#contact').offset().top;
              $("html, body").animate({
                scrollTop: scrollHeight
              }, 300);
            };
          }
        })
      };

      function processOrderContent(){
        $('#submitButton').addClass('completed');
        $('#ajaxLoader').addClass('loading_state');
        // お名前
        var userName = target.find("input[name=yourName]").val();
        // メールアドレス
        var userMail = target.find("input[name=yourMail]").val();
        //会社名
        var corpname = target.find("input[name=corpname]").val();
        //会社名
        var phonenumber = target.find("input[name=phonenumber]").val();
        var content = target.find("textarea[name=contents]").val();
        event.preventDefault();
        if(location.host == 'diffar.jp'){
          var ajaxSend = "https://docs.google.com/forms/u/1/d/e/1FAIpQLScMC6oPGTshdUlraQ_u9-MSwkyuLWjQ9hnDp84QfqNaqPZhDA/formResponse";
        }else{
          var ajaxSend = "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfsrFG7WxSqmOKUeVSvHLRSgPrjCQc5vNo_6Cb30WreTltEOw/formResponse";
        }
          $.ajax({
            url: ajaxSend,
            data: {
              "entry.1771537453": userName,
              "entry.121204646": userMail,
              "entry.1488244052": corpname,
              "entry.121999292": phonenumber,
              "entry.672207042": content,
            },
            type: "POST",
            dataType: "xml",
            statusCode: {
              0: function () {
                setTimeout(function() {
                  $('#ajaxLoader').removeClass('loading_state');
                  $('#submitButton').remove();
                  if(location.host == 'diffar.jp'){
                    $('#statusMessage').addClass('complete').html('<span class="text">入力内容は正常に送信されました。<span>自動返信メールをご確認ください。</span></span>');
                  }else{
                    $('#statusMessage').addClass('complete').html('<span class="text">Your input has been successfully submitted. <span>Please check your automatic reply email.</span></span>');
                  }

              }, 1000);
            },
              200: function () {
                $('#ajaxLoader').removeClass('loading_state');
                $('#submitButton').remove();
                $('#statusMessage').addClass('error').html('<span class="text">送信に失敗しました。お手数ではございますが、時間を置いてもう一度お試しください。</span>');
                setTimeout(function() {
                  location.href = 'https://' + location.hostname + '/'
              }, 3000);
            }
          }
        });
      }

      init();

    };

    if (document.getElementById('contactWrap')) {
      setMyForm($('#contactWrap'));
    }


    // ウェイティングリストの登録フォーム
    function setWaitingForm(target){
      var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
      var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
      var errorCount = 0;
      var submitWrap = $('#registerSubmit');
      var submitButton = $('#registerSubmit input');
      var items = []; //チェック対象となるテキスト入力要素を格納した配列

      //項目チェックする
      var checkAll = function(){
        errorCount = 0;

        //input,textareaのチェック
        for( var i=0; i<items.length; i++ ){
          if( items[i].prop('isSuccess') == false ){
            errorCount++;
            console.log('error:' + i);
          };
        };

        if( errorCount == 0 ){
        }else{
        };
      };

      //エラーメッセージの追加
      var addErrorMessage = function(selector, msg){
        removeErrorMessage(selector);
        selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
        selector.addClass(ERROR_INPUT_CLASSNAME);
      };

      //エラーメッセージの削除
      var removeErrorMessage = function(selector){
        var msgSelector = selector.parent().parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
        if( msgSelector.length != 0 ){
          msgSelector.remove();
          selector.removeClass(ERROR_INPUT_CLASSNAME);
        };
      };

      //input,textareaの未入力チェック
      var checkEmptyText = function(selector, msg){
        if( selector.val() == '' ||  selector.val() == null){
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        }else{
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        };
      };

      var emptyThrough = function(selector){
        if( selector.val() == '' ||  selector.val() == null){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }
      };

      //radioの未入力チェック
      var checkRadioBox = function(selector, msg){
        if( selector.prop("checked")){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }else{
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        };
      };

      //文字列のフォーマットチェック
      function checkFormatText(selector, _mode, msg){
        var value = selector.val();
        switch(_mode){
          //全角のみ
          case 0:
            if(value.match(/^[^ -~｡-ﾟ]*$/)){
              selector.prop('isSuccess', true);
              removeErrorMessage(selector);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //ふりがなのみ
          case 1:
            if(value.match(/^[\u3040-\u309F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //半角数字のみ
          case 2:
            if(value.match(/^[0-9\-]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //メールアドレスかどうか
          case 3:
            if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //カタカナのみ
          case 4:
            if(value.match(/^[\u30A0-\u30FF]+$/) || value.match(/^[\uFF61-\uFF9F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //全てエラーにする
          case 5:
            selector.prop('isSuccess', false);
            break;
        };
        if( selector.prop('isSuccess') == false ){
          addErrorMessage(selector, msg);
        }else{
          removeErrorMessage(selector);
        };
      };

      //初期設定
      var init = function(){
        //submitイベントの設定
        target.on({
          'submit': function(){
            checkAll();
          }
        });
        //input要素を配列に格納
        items = [
          target.find('input[name="yourMail"]'), //0 メールアドレス
        ];
        //input要素のプロパティを設定
        $.each(items, function(index){
          items[index].prop('isSuccess', false);
        });

        //enterキーでsubmitしてしまうのを防止する
        target.find('input[type=text]').on({
          'keypress': function(e){
            if( (e.keyCode == 13) ) return false;
          }
        });

        //1 メールアドレス
        items[0].on({
          'blur': function(){
            checkEmptyText( items[0], '※メールアドレスをご入力ください。' );
            if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, 'アドレスの形式をご確認ください' );
            checkAll();
          }
        });

        submitButton.on({
          'click': function(){
            checkEmptyText( items[0], '※メールアドレスをご入力ください。' );
            if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, 'アドレスの形式をご確認ください' );
            checkAll();
            if( errorCount == 0 ){
              processOrderContent();
            }else{
              alert('入力内容に不備があります。入力内容を確認いただき、再度送信ボタンを押してください。');
              var scrollHeight = $('#contact').offset().top;
              $("html, body").animate({
                scrollTop: scrollHeight
              }, 300);
            };
          }
        })
      };

      function processOrderContent(){
        $('#registerSubmit').addClass('completed');
        $('#ajaxLoader').addClass('loading_state');
        // メールアドレス
        var userMail = target.find("input[name=yourMail]").val();
        event.preventDefault();
        $.ajax({
          url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSew_fyaEGXkE0EUkzjTHZbnzdlULXu9-cyqTbTt-fnEfinEqw/formResponse",
          data: {
            "entry.1498753643": userMail,
          },
          type: "POST",
          dataType: "xml",
          statusCode: {
            0: function () {
              setTimeout(function() {
                $('#ajaxLoader').removeClass('loading_state');
                $('#registerSubmit').remove();
                $('#statusMessage').addClass('complete').html('<span class="text">ウェイティングリストへの登録が完了しました。</span>');
              }, 1000);
            },
            200: function () {
              $('#ajaxLoader').removeClass('loading_state');
              $('#registerSubmit').remove();
              $('#statusMessage').addClass('error').html('<span class="text">ウェイティングリストへの登録が完了に失敗しました。お手数ではございますが、時間を置いてもう一度お試しください。</span>');
              setTimeout(function() {
                location.href = 'https://' + location.hostname + '/'
              }, 3000);
            }
          }
        });
      }

      init();

    };

    if (document.getElementById('registerMember')) {
      setWaitingForm($('#registerMember'));
    }

    //商品別ウェイティングリストの登録フォーム
    function setProductWaitingList(wrapper){
      var waitingButton = $('#waitingButton');
      var waitingCloseButton = $('#waitingCloseButton');
      var waitingPopBg = $('#waitingPopBg');



      function setProdWaitingForm(target){
        var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
        var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
        var errorCount = 0;
        var submitWrap = $('#registerSubmit');
        var submitButton = $('#registerSubmit input');
        var items = []; //チェック対象となるテキスト入力要素を格納した配列

        if(location.host == 'diffar.jp'){
          var mailInputArart = '※メールアドレスをご入力ください。';
          var mailFormatArrat = '※アドレスの形式をご確認ください';
        }else{
          var mailInputArart = '*Please enter your email address.';
          var mailFormatArrat = '*Please check the address format';
        }

        //項目チェックする
        var checkAll = function(){
          errorCount = 0;

          //input,textareaのチェック
          for( var i=0; i<items.length; i++ ){
            if( items[i].prop('isSuccess') == false ){
              errorCount++;
              console.log('error:' + i);
            };
          };

          if( errorCount == 0 ){
          }else{
          };
        };

        //エラーメッセージの追加
        var addErrorMessage = function(selector, msg){
          removeErrorMessage(selector);
          selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
          selector.addClass(ERROR_INPUT_CLASSNAME);
        };

        //エラーメッセージの削除
        var removeErrorMessage = function(selector){
          var msgSelector = selector.parent().parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
          if( msgSelector.length != 0 ){
            msgSelector.remove();
            selector.removeClass(ERROR_INPUT_CLASSNAME);
          };
        };

        //input,textareaの未入力チェック
        var checkEmptyText = function(selector, msg){
          if( selector.val() == '' ||  selector.val() == null){
            addErrorMessage(selector, msg);
            selector.prop('isSuccess', false);
          }else{
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          };
        };

        var emptyThrough = function(selector){
          if( selector.val() == '' ||  selector.val() == null){
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          }
        };

        //radioの未入力チェック
        var checkRadioBox = function(selector, msg){
          if( selector.prop("checked")){
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          }else{
            addErrorMessage(selector, msg);
            selector.prop('isSuccess', false);
          };
        };

        //文字列のフォーマットチェック
        function checkFormatText(selector, _mode, msg){
          var value = selector.val();
          switch(_mode){
            //全角のみ
            case 0:
              if(value.match(/^[^ -~｡-ﾟ]*$/)){
                selector.prop('isSuccess', true);
                removeErrorMessage(selector);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //ふりがなのみ
            case 1:
              if(value.match(/^[\u3040-\u309F]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //半角数字のみ
            case 2:
              if(value.match(/^[0-9\-]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //メールアドレスかどうか
            case 3:
              if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //カタカナのみ
            case 4:
              if(value.match(/^[\u30A0-\u30FF]+$/) || value.match(/^[\uFF61-\uFF9F]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //全てエラーにする
            case 5:
              selector.prop('isSuccess', false);
              break;
          };
          if( selector.prop('isSuccess') == false ){
            addErrorMessage(selector, msg);
          }else{
            removeErrorMessage(selector);
          };
        };

        //初期設定
        var init = function(){
          //submitイベントの設定
          target.on({
            'submit': function(){
              checkAll();
            }
          });
          //input要素を配列に格納
          items = [
            target.find('input[name="yourMail"]'), //0 メールアドレス
          ];
          //input要素のプロパティを設定
          $.each(items, function(index){
            items[index].prop('isSuccess', false);
          });

          //enterキーでsubmitしてしまうのを防止する
          target.find('input[type=text]').on({
            'keypress': function(e){
              if( (e.keyCode == 13) ) return false;
            }
          });

          //1 メールアドレス
          items[0].on({
            'blur': function(){
              checkEmptyText( items[0], mailInputArart );
              if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, mailFormatArrat );
              checkAll();
            }
          });

          submitButton.on({
            'click': function(){
              checkEmptyText( items[0], mailInputArart);
              if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, mailFormatArrat );
              checkAll();
              if( errorCount == 0 ){
                processOrderContent();
              }else{
                alert('入力内容に不備があります。入力内容を確認いただき、再度送信ボタンを押してください。');
                var scrollHeight = $('#contact').offset().top;
                $("html, body").animate({
                  scrollTop: scrollHeight
                }, 300);
              };
            }
          })
        };

        function processOrderContent(){
          $('#registerSubmit').addClass('completed');
          $('#ajaxLoader').addClass('loading_state');
          // メールアドレス
          var location = target.find("input[name=location]").val();
          var prodID = target.find("input[name=prodID]").val();
          var userMail = target.find("input[name=yourMail]").val();
          event.preventDefault();
          $.ajax({
            url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSc1_WSxMK6Nn77E443jC5Uvdre469FZKUFatzZyGpPvDFa_4g/formResponse",
            data: {
              "entry.2060695486": location,
              "entry.1520439532": prodID,
              "entry.1838744146": userMail,
            },
            type: "POST",
            dataType: "xml",
            statusCode: {
              0: function () {
                setTimeout(function() {
                  $('#ajaxLoader').removeClass('loading_state');
                  $('#registerSubmit').remove();
                  if(location.host == 'diffar.jp'){
                    $('#statusMessage').addClass('complete').html('<span class="text">ウェイティングリストへの登録が完了しました。</span>');
                  }else{
                    $('#statusMessage').addClass('complete').html('<span class="text">Your registration on the waiting list has been completed.</span>');
                  }
                }, 1000);
              },
              200: function () {
                $('#ajaxLoader').removeClass('loading_state');
                $('#registerSubmit').remove();
                if(location.host == 'diffar.jp'){
                  $('#statusMessage').addClass('error').html('<span class="text">ウェイティングリストへの登録が完了に失敗しました。お手数ではございますが、時間を置いてもう一度お試しください。</span>');
                }else{
                  $('#statusMessage').addClass('error').html('<span class="text">Registration to the waiting list has failed. We apologize for the inconvenience, but please try again later.</span>');
                }
                setTimeout(function() {
                  location.href = 'https://' + location.hostname + '/'
                }, 3000);
              }
            }
          });
        }

        init();

      };

      function init(){

        waitingButton.on({
          'click': function() {
            wrapper.addClass('open');
          }
        });

        waitingCloseButton.on({
          'click': function() {
            wrapper.removeClass('open');
          }
        });

        waitingPopBg.on({
          'click': function() {
            wrapper.removeClass('open');
          }
        });

        setProdWaitingForm($('#prodWaitingForm'));


      }

      init();

    }

    if (document.getElementById('waitingPop')) {
      setProductWaitingList($('#waitingPop'));
    }

  }

  preSetScript();

  //PJAXの制御
  function pjaxControll(){
    var linkTarget = [];
    var linkType = [];
    var linkURL = [];
    var humButton = $('#humButton button')

    function addPjaxClass() {
      $.each($('body').find('a'), function(index) {
        linkTarget[index] = $(this).attr('target');
        linkType[index] = $(this).attr('linkType');
        if(linkTarget[index] != '_blank' || linkTarget[index] == undefined ){
          if(linkType[index] != 'langChange'){
            $(this).addClass('pjax');
          }
        }
      });
    }

    addPjaxClass();

    // pjax遷移開始
    var nextUrl = '';
    $(document).on('click', '.pjax', function(e) {
      var linkType = $(this).attr('target');
      var linkProp = $(this).attr('linkType');
      var linkURL = $(this).attr('href');
      $.each($('body').find('a'), function(index) {
        /*$(this).css('pointer-events', 'none');*/
      });
      if(linkType != '_blank' || linkType == undefined){
        if(linkURL != '/cart'){
          e.preventDefault();
          nextUrl = $(this).attr('href');
          $('#hEnLink').attr('href', 'https://diffar.net' + nextUrl);
          $('#hJpLink').attr('href', 'https://diffar.jp' + nextUrl);
          if(linkProp == 'headerLink'){
            setTimeout(function() {
              $('#humButton').click();
            }, 500);
          }
          if(nextUrl.indexOf('logout') == -1){
            // 遷移先のURLを取得
            $('#container').animate({opacity:0}, 250, function(){
                $.pjax({//エフェクトが終わったらPjaxイベント
                    url: nextUrl,
                    container: '#container',
                    fragment: '#container',
                    timeout: 5000,
                });
            });
          }else{
            location.href = nextUrl;
          }
        }
      }
    });

    $(document).on('change', '.pjax-select', function(e) {
        var nextUrl = '';
        e.preventDefault();
        nextUrl = $(this).val();
        // 遷移先のURLを取得
        $('#innerWrapper').animate({opacity:0}, 250, function(){
            $.pjax({//エフェクトが終わったらPjaxイベント
                url: nextUrl,
                container: '#innerWrapper',
                fragment: '#innerWrapper',
                timeout: 5000,
            });

        });
    });

    //Pjaxイベントが終わったときの動作
    $(document).on('pjax:end', function() {
      addPjaxClass();
      /*asyncLoad();*/
      $.each($('body').find('a'), function(index) {
        /*$(this).css('pointer-events', 'all');*/
      });
      $('#container').animate({ opacity: 1 }, 250, function() {
        preSetScript();
      });
      $('#innerWrapper').animate({ opacity: 1 }, 250, function() {});
    });

    // タイムアウト時
    $(document).on('pjax:timeout', function() {
      location.href = nextUrl;
      $('#container').animate({opacity:1}, 250);
      $('#innerWrapper').animate({ opacity: 1 }, 250, function() {});
      preSetScript();
      addPjaxClass();
    });

  }

  pjaxControll();


});
